import { SxProps, Theme } from '@mui/material';
import { commonStyles } from '~/theme/styles/commonStyles';

type Styles = {
  actionBtnIcon: SxProps<Theme>;
  actionBtnsContainer: (theme: Theme) => SxProps<Theme>;
  headerItem: (theme: Theme) => SxProps<Theme>;
  header: SxProps<Theme>;
  item: (theme: Theme) => SxProps<Theme>;
  container: SxProps<Theme>;
  tableCell: SxProps<Theme>;
  mobileTableCell: SxProps<Theme>;
};

export const styles: Styles = {
  actionBtnIcon: { width: 16, height: 16 },
  actionBtnsContainer: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.5),
    padding: 0,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
      gap: theme.spacing(2),
      padding: theme.spacing(1),
      background: theme.palette.common.white,
    },
  }),
  item: (theme: Theme) => ({
    borderRight: `1px solid ${theme.palette.grey[100]}`,
    '&:last-child': {
      borderRight: 'none',
      borderBottom: 'none',
    },
    [theme.breakpoints.down('md')]: {
      borderRight: 'none',
      background: theme.palette.common.white,
    },
    borderBottom: {
      sm: `1px solid ${theme.palette.grey[100]}`,
      xs: `1px solid ${theme.palette.grey[100]}`,
      md: 'none',
    },
  }),
  headerItem: (theme: Theme) => ({
    padding: theme.spacing(1),
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
  }),
  header: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    top: 0,
    zIndex: 1,
    background: theme.palette.background.paper,
  }),
  container: (theme: Theme) => ({
    ...(commonStyles.scroll(theme) as Object),
    overflowY: 'auto',
    maxHeight: '300px',
    background: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[100]}`,
    [theme.breakpoints.down('sm')]: {
      border: 'none',
    },
  }),
  mobileTableCell: (theme: Theme) => ({
    pl: 1,
    alignItems: 'center',
    display: 'flex',
    borderRight: `1px solid ${theme.palette.grey[100]}`,
  }),
  tableCell: {
    pl: { sm: 1, md: 0, xs: 1 },
    pr: { sm: 1, md: 0, xs: 1 },
    size: { md: 12, sm: 6, xs: 6 },
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
};
